import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shareResult", "shareUrl", "qrResult", "qrCode"]
  static values = { shareUrl: String, qrUrl: String }

  async showShareModal() {
    try {
      const response = await fetch(this.shareUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        if (this.hasShareUrlTarget) {
          this.shareUrlTarget.value = data.url
        }
        if (this.hasShareResultTarget) {
          this.shareResultTarget.classList.remove("hidden")
        }
        if (this.hasQrResultTarget) {
          this.qrResultTarget.classList.add("hidden")
        }
      }
    } catch (error) {
      console.error('Error generating share link:', error)
    }
  }

  async generateQRCode() {
    try {
      const response = await fetch(this.qrUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        if (this.hasQrCodeTarget) {
          if (data.svg) {
            this.qrCodeTarget.innerHTML = data.svg
          } else if (data.qr_api_url) {
            this.qrCodeTarget.innerHTML = `<img src="${data.qr_api_url}" alt="QR Code" class="w-full h-full" />`
          }
        }
        if (this.hasQrResultTarget) {
          this.qrResultTarget.classList.remove("hidden")
        }
        if (this.hasShareResultTarget) {
          this.shareResultTarget.classList.add("hidden")
        }
      }
    } catch (error) {
      console.error('Error generating QR code:', error)
    }
  }

  copyLink() {
    if (this.hasShareUrlTarget) {
      navigator.clipboard.writeText(this.shareUrlTarget.value)
        .then(() => {
          // Show temporary success feedback
          const button = this.element.querySelector('[data-action="click->activity-participants#copyLink"]')
          if (button) {
            const originalHTML = button.innerHTML
            button.innerHTML = '<svg class="w-5 h-5 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17L4 12"/></svg>'
            setTimeout(() => {
              button.innerHTML = originalHTML
            }, 2000)
          }
        })
        .catch(err => {
          console.error('Failed to copy:', err)
        })
    }
  }
}
